'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



// WEBPACK FOOTER //
// ./src/frontend-lib/node_modules/function-bind/index.js